import { singleCloseMutation } from "api/graphqlTypes";
import { RecordId } from "config/config";
import { ParentReference } from "containers/Projects/components/ProjectTree/interfaces";
import { actions as resourcesActions } from "containers/Resources/Resources.reducer";
import { History } from "history";
import { Dispatch } from "redux";
import { getRelativeUrl } from "utils/service";

/**
 * Pins or unpins a record in the sidebar. `recordUserId` is the RECORD_USER row
 * the UI holds (may be stale or missing); pass `record` (record id + the
 * current user's identity id) so a missing row is created when pinning.
 */
const setPinned = (
    dispatch: Dispatch,
    recordUserId: RecordId | null | undefined,
    pinnedState: boolean,
    record?: { recordId?: string | null; userId?: string | null }
) =>
    new Promise((resolve, reject) => {
        dispatch({
            type: pinnedState
                ? resourcesActions.START_PINNING_RESOURCE
                : resourcesActions.START_UNPINNING_RESOURCE,
            promise: { resolve, reject },
            params: {
                recordUserId,
                recordId: record?.recordId,
                userId: record?.userId,
                pinned: pinnedState,
            },
        });
    }).catch((error) => error);

const close = (
    dispatch: Dispatch,
    history: History,
    recordUserId: RecordId,
    parent?: ParentReference
) =>
    new Promise((resolve, reject) => {
        const variables = { id: recordUserId };
        dispatch({
            type: resourcesActions.START_CLOSING_RESOURCE,
            promise: { resolve, reject },
            params: {
                query: singleCloseMutation,
                variables,
            },
        });
    })
        .then(() => {
            if (parent) {
                history.push(getRelativeUrl(parent.recordType, parent.id));
            }
        })
        .catch((error) => error);

export { setPinned, close };
